module.exports = __webpack_public_path__ + "img/wb7@2x.2fe7698b.png";